<template>
  <div>
    <TitleCard :titleMsg1="titleMsg1" :titleMsg2="titleMsg2" :titleMsg3="titleMsg3" :titleMsg4="titleMsg4"></TitleCard>

    <a-card class="all-card-style ">

      <a-form-model ref="video" :rules="FormRules" :model="model" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }" >

        <a-form-model-item v-if="!model.ID" label="设备序列号"  class="ant-form-item2 ">
          <a-input v-model="model.cDeviceSN" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item v-if="!model.ID" label="设备校验码" class="ant-form-item2 ">
          <a-input v-model="model.validateCode" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item prop="cDeviceName" label="设备名称" class="ant-form-item2 ">
          <a-input v-model="model.cDeviceName" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item prop="cDeviceAsName" label="设备别名" class="ant-form-item2 ">
          <a-input v-model="model.cDeviceAsName" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item  label="设备地址"  class="ant-form-item2 ">
          <a-select v-model="model.AddressType"  class="ant-form-item3 " >
            <a-select-option  value="精准投喂">
             精准投喂
            </a-select-option>
            <a-select-option  value="数据展示">
              数据展示
            </a-select-option>
            <a-select-option  value="疾病分析">
              疾病分析
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="AppKey" label="KeySecret"  class="ant-form-item2">
          <a-select v-model="model.AppKey" @change="keySelect"  class="ant-form-item3 ">
            <a-select-option v-for="(item,index) in AppKeySelectItems" :value="item.cAppId">
              {{item.cAppId}}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="cPlatformID" label="所属项目"  class="ant-form-item2 ">
          <a-select v-model="model.cPlatformID" @change="platformSelect"  class="ant-form-item3 ">
            <a-select-option v-for="(item,index) in platformSelectItems" :value="item.ID">
              {{item.cPlatformName}}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="cSceneID" label="所属场地" class="ant-form-item2 " >
          <a-select v-model="model.cSceneID"  @change="sceneformSelect" class="ant-form-item3 " >
            <a-select-option v-for="(item,index) in sceneformSelectItems" :value="item.ID">
              {{item.cSceneName}}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item :wrapper-col="{ span: 12, offset: 2 }">
          <a-button type="primary" html-type="button" @click="SaveForms">
            确定
          </a-button>
        </a-form-model-item>

      </a-form-model>


    </a-card>
  </div>
</template>

<script>
  import TitleCard from '@/components/TitleCard.vue'
  import { _getEntPlatFormData } from '@/common/request'

  export default {
    name: 'videoManagementForm',
    components: {
      TitleCard
    },
    data() {
      return {
        titleMsg1: "设备管理",
        titleMsg2:'视频管理',
        titleMsg3:'视频管理',
        titleMsg4:'新增',
        model:{},
      platformSelectItems:[],
        AppKeySelectItems:[],
        queryPlatformInfo:{
          cEntID:"",
          keyword:""
        },
        sceneformSelectItems:[],
        FormRules:{
          cDeviceAsName:[
            { required: true, message: '请输入设备别名', trigger: 'blur' }
          ],
          AppKey: [
            { required: true, message: '请选择AppKey', trigger: 'change' }
          ],

          cPlatformID:
            [
              { required: true, message: '请选择所属项目', trigger: 'change' }
            ],
          cSceneID: [
            { required: true, message: '请选择所属场地', trigger: 'change' }
          ],

          cDeviceName: [
            { required: true, message: '请输入设备名称', trigger: 'blur' }
          ]
        },

      }
    },
    mounted () {
      let that=this;
      that.queryPlatformInfo.cEntID=that.$store.getters.User.enterprise.ID;
      if (that.$route.params.ID) {
        that.model.ID = that.utils.deepClone(that.$route.params.ID);
        that.HandleDetail();
      }
      that.getEntPlatFormData()
      that.getKeySecretData();
    },
    methods:{
      sceneformSelect(){
        let that=this;
        that.model.cSceneName=this.sceneformSelectItems.filter(s=>s.ID==that.model.cSceneID)
      },
      keySelect(){
        let that=this;
        that.model.APPSecret=this.AppKeySelectItems.filter(s=>s.AppKey==that.model.AppKey)
      },
      platformSelect(){

        this.getSceneData()
      },
      async HandleDetail () {
        var that = this;

        let res = await that.$http.post('HkCamera/FindById/' + that.model.ID, null)

        if (res.data.code == "200") {
          that.model = res.data.obj.data;
        } else {

        }
      },
      /*获取项目列表*/
      async getEntPlatFormData(){
        var that=this
        let res=await  _getEntPlatFormData(this,this.queryPlatformInfo)


        if(res.data.data.code=="200"){

          that.platformSelectItems=res.data.data.obj.list
          if(that.platformSelectItems.length>0) {
            that.model.cPlatformID=that.platformSelectItems[0].ID

            this.getSceneData()
          }
        }

      },
      async getSceneData(){
        var that=this
        let res=await that.$http.post('EntSceneInfo/List',{cSystemCode:'设施园艺',cPlatformID:that.model.cPlatformID})

        if(res.data.code=="200"){

          that.sceneformSelectItems=res.data.obj.list

          if(that.sceneformSelectItems.length>0) {
            that.model.cSceneID=that.sceneformSelectItems[0].ID
            that.model.cSceneName=that.sceneformSelectItems[0].cSceneName

          }
        }

      },
      async getKeySecretData(){
        var that=this
        let res=await that.$http.post('HkCamera/GetKeySecretList',{cEntID:that.$store.getters.User.enterprise.ID})

        if(res.data.code=="200"){

          that.AppKeySelectItems=res.data.obj.list

          if(that.AppKeySelectItems.length>0) {
            that.model.AppKey=that.AppKeySelectItems[0].cAppId
            that.model.APPSecret=that.AppKeySelectItems[0].cAppPwd

          }
        }

      },
      async SaveForms () {
        let that = this;
        let form=that.$refs['video'];
        form.validate(async valid => {

          if (valid) {
            that.model.cEntID=that.$store.getters.User.enterprise.ID;
            that.model.cSystemCode='设施园艺';

            let url='';
            if (that.model.ID){
              url='HkCamera/UpdateSave';
            }else{
              url='HkCamera/InsertSave';
            }
            let res = await that.$http.post(url, that.model)
            if (res.data.code == "200") {
              that.$message.success('保存成功!')
              that.$router.push({name:'videoManagementList'});
            } else {
              that.$message.error(res.data.message)

            }
          } else {
            that.$message.error('校验失败!')
          }
        });
      }
    }
  }
</script>


